"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMaxConstraint = void 0;
const isMaxConstraint = (constraint) => {
    return constraint.name === 'max';
};
exports.isMaxConstraint = isMaxConstraint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF4LmNvbnN0cmFpbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RyYWludHMvbWF4LmNvbnN0cmFpbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBT08sTUFBTSxlQUFlLEdBQUcsQ0FBQyxVQUEwQixFQUErQixFQUFFO0lBQ3pGLE9BQU8sVUFBVSxDQUFDLElBQUksS0FBSyxLQUFLLENBQUE7QUFDbEMsQ0FBQyxDQUFBO0FBRlksUUFBQSxlQUFlLG1CQUUzQiJ9